'use client';

import { FRED_RANGES, type FredRange } from '@/lib/fred-series';

interface RangeSelectorProps {
  value: FredRange;
  onChange: (range: FredRange) => void;
}

export function RangeSelector({ value, onChange }: RangeSelectorProps) {
  return (
    <div className="flex items-center gap-1">
      {FRED_RANGES.map((r) => (
        <button
          key={r}
          type="button"
          onClick={() => onChange(r)}
          className={`px-2 py-0.5 text-xs font-mono transition-colors ${
            value === r
              ? 'bg-[var(--color-accent)] text-white'
              : 'text-[#6B7280] hover:text-[#E5E7EB] hover:bg-[#1F2937]'
          }`}
        >
          {r}
        </button>
      ))}
    </div>
  );
}
